import { ProductPageLayout } from '../components/ProductPageLayout';

export function ImageGenPage() {
    return <ProductPageLayout productId="image-gen" />;
}
